import angular from 'angular';
import ImageViewerComponent from './image-viewer.component';

const ImageViewerModule = angular
    .module('control-room.commons.content.components.image-viewer', [])
    .component('crImageViewer', ImageViewerComponent);

export default ImageViewerModule;
